// Pano kartlarının modül kapıları — İKİ AYRI SORU (2026-10-05, prod'da raporlanan hata):
//
//  1. Kişisel kart/kısayol: "bu modülü KENDİM kullanabiliyor muyum?" → kiracı aboneliği + koltuk.
//     Sol menüdeki /my-* öğeleri (MenuConfig `privileges: []` + `module`, SidebarMenu.hasAccess)
//     ve backend'in self-servis uçları da yalnız bunu sorar.
//  2. Şirket geneli kart: "bu modülü YÖNETEBİLİYOR muyum?" → ayrıcalık (canRead/canWrite).
//
// KÖK NEDEN: pano ikisini de canRead ile soruyordu (kısayollar `hasModule` yardımcısından ÖNCE
// yazıldı; 931e15f7 sol menüyü düzeltti, panoyu kapsamadı). Satın alınan modülde ayrıcalık yalnız
// rolle gelir (AuthorizeDataAccess.BuildUserPrivileges) — tüm modüllere abone kiracıda rolsüz
// çalışan kendi izin bakiyesini, kendi anketlerini ve kişisel kısayolları göremiyordu.
//
// hasSeat ölçümsüz/varsayılan modülde ve `seats` alanı olmayan eski oturumda true döner; yani
// ölçümsüz kiracıda (1) yalnız aboneliğe bakar. resolveCanUsePm PM için aynı ilkeldir.
//
// Ayrı saf dosya: resolveCanUsePm.js ile AYNI gerekçe — DashboardPage'i test dosyasından import
// etmek CRA5 + axios ESM zincirine toslar; bu dosya hiçbir şey import etmez.
export function resolveCanUseSelfService(code, { hasModule, hasSeat }) {
  return hasModule(code) && hasSeat(code);
}

export function resolveDashboardGates({ canRead, hasModule, hasSeat }) {
  return {
    // Şirket geneli sayı + liste; kart LM.Write isteyen /all-leaves'e gider — yönetim yüzeyi.
    canSeeOnLeaveToday: canRead('LM'),
    // Kendi izin bakiyesi (/v1/dashboard/leave-summary yalnız [Authorize]).
    canUseLeaves: resolveCanUseSelfService('LM', { hasModule, hasSeat }),
    // Kişiye atanmış bekleyen anket sayısı; kart /my-surveys'e gider.
    canUseSurveys: resolveCanUseSelfService('SV', { hasModule, hasSeat }),
  };
}
